export default __webpack_public_path__ + "media/zurb/img/experience-design/stat-table3-883910e2f5f439c7ea4f91ec915e9d33.png";